var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MobileServiceOverview',_vm._b({staticClass:"academic-services-view",attrs:{"hero-image":_vm.academicServicesHeroImage}},'MobileServiceOverview',_vm.academicServicesOverview,false))
}
var staticRenderFns = []

export { render, staticRenderFns }